module.exports = __webpack_public_path__ + "img/icp.4693627f.svg";